export default __webpack_public_path__ + "static/media/Ameeta_Soni_AHV_In_Moms_We_Trust.dd714308.jpg";